import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import { useTimeSpan } from './hooks/useTimeSpan';

const LabelValue = ({ label, value, mono = false }) => (
  <div className="flex flex-col items-center">
    <div className="text-xs text-gray-500">{label}</div>
    <div className={`text-sm font-medium ${mono ? 'font-mono' : ''}`}>{value ?? '—'}</div>
  </div>
);

const Badge = ({ children }) => (
  <span className="px-2 py-1 text-xs rounded-full bg-blue-50 text-blue-700 border border-blue-200">
    {children}
  </span>
);

const TimeSpanTile = ({ activeFile }) => {
  const { data, loading, error } = useTimeSpan(activeFile);

  const startDate = data?.start_timestamp ? data.start_timestamp.split('T')[0] : null;
  const endDate = data?.end_timestamp ? data.end_timestamp.split('T')[0] : null;

  return (
    <BaseTile
      title="Dataset Time Span"
      loading={loading}
      error={error}
      minHeight="sm"
      padding="default"
    >
      <div className="flex flex-col gap-4 h-full justify-center">
        {/* Pretty summary */}
        <div className="text-center text-base font-semibold text-gray-800">
          {data?.pretty || '—'}
        </div>

        {/* Start/End row */}
        <div className="flex items-center justify-center gap-8">
          <LabelValue label="Start" value={startDate} mono />
          <svg className="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"><path d="M7 4l6 6-6 6"/></svg>
          <LabelValue label="End" value={endDate} mono />
        </div>

        {/* Duration badges */}
        <div className="flex items-center justify-center gap-2 flex-wrap">
          <Badge>{data?.duration_days != null ? `${data.duration_days} days` : '—'}</Badge>
          <Badge>{data?.duration_weeks != null ? `${data.duration_weeks} weeks` : '—'}</Badge>
          <Badge>{data?.duration_months_approx != null ? `${data.duration_months_approx} months` : '—'}</Badge>
        </div>
      </div>
    </BaseTile>
  );
};

export default TimeSpanTile;
